module.exports = __webpack_public_path__ + "03_long_yellow.fb4af5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_long_yellow.png
// module id = yr1l
// module chunks = 0